import { Timer } from 'utils/timer-manager/timer-manager';

declare global {
  interface Window {
    runningTimers: Timer[];
  }
}

if (!Array.isArray(window.runningTimers)) window.runningTimers = [];
